export default __webpack_public_path__ + "static/media/forcefield.82274ba9.png";